import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appSetFocusOnLoad]'
})
export class SetFocusOnLoadDirective implements AfterViewInit {

  constructor(private readonly host: ElementRef) { }

  ngAfterViewInit() {
    setTimeout(() => this.host.nativeElement.focus())
  }

}
